export const buildTableTransferPayload = ({
  sourceTable,
  targetTable,
  stewardModeEnabled = false,
  mode = "table",
}) => ({
  sourceTableId: sourceTable?.id,
  targetTableId: targetTable?.id,
  ...(stewardModeEnabled && mode === "steward"
    ? {
        transferMode: "steward",
        expectedSourceCycle: sourceTable?.occupancy_cycle,
        expectedTargetCycle: targetTable?.occupancy_cycle,
      }
    : {}),
});

export const getStewardTransferTargets = ({
  enabled = false,
  groups = [],
  sourceTableId,
}) => {
  if (!enabled) return [];
  const sourceGroupKey = groups.find((group) =>
    (group?.tables || []).some(
      (table) => String(table?.id) === String(sourceTableId || ""),
    ),
  )?.key;
  return groups.filter(
    (group) =>
      group?.key !== "unassigned" &&
      group?.key !== sourceGroupKey &&
      (group?.tables || []).length > 0,
  );
};
